"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseLicenseBatchDto = instanceOfNurseLicenseBatchDto;
exports.NurseLicenseBatchDtoFromJSON = NurseLicenseBatchDtoFromJSON;
exports.NurseLicenseBatchDtoFromJSONTyped = NurseLicenseBatchDtoFromJSONTyped;
exports.NurseLicenseBatchDtoToJSON = NurseLicenseBatchDtoToJSON;
exports.NurseLicenseBatchDtoToJSONTyped = NurseLicenseBatchDtoToJSONTyped;
const State_1 = require("./State");
const LicenseStatus_1 = require("./LicenseStatus");
const NurseNursysTransactionDto_1 = require("./NurseNursysTransactionDto");
const CompactStatus_1 = require("./CompactStatus");
/**
 * Check if a given object implements the NurseLicenseBatchDto interface.
 */
function instanceOfNurseLicenseBatchDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined)
        return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined)
        return false;
    if (!('statusLastUpdatedAt' in value) || value['statusLastUpdatedAt'] === undefined)
        return false;
    if (!('compactStatus' in value) || value['compactStatus'] === undefined)
        return false;
    if (!('lastNursysTransactionId' in value) || value['lastNursysTransactionId'] === undefined)
        return false;
    if (!('licenseNursysTransactions' in value) || value['licenseNursysTransactions'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('ncsbnId' in value) || value['ncsbnId'] === undefined)
        return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    if (!('line1' in value) || value['line1'] === undefined)
        return false;
    if (!('line2' in value) || value['line2'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined)
        return false;
    return true;
}
function NurseLicenseBatchDtoFromJSON(json) {
    return NurseLicenseBatchDtoFromJSONTyped(json, false);
}
function NurseLicenseBatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'nurseProfileId': json['nurseProfileId'],
        'licenseNumber': json['licenseNumber'],
        'jurisdiction': (0, State_1.StateFromJSON)(json['jurisdiction']),
        'licenseType': json['licenseType'],
        'status': (0, LicenseStatus_1.LicenseStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'],
        'expirationDate': (json['expirationDate'] == null ? null : new Date(json['expirationDate'])),
        'statusLastUpdatedAt': (json['statusLastUpdatedAt'] == null ? null : new Date(json['statusLastUpdatedAt'])),
        'compactStatus': (0, CompactStatus_1.CompactStatusFromJSON)(json['compactStatus']),
        'lastNursysTransactionId': json['lastNursysTransactionId'],
        'licenseNursysTransactions': (json['licenseNursysTransactions'] == null ? null : json['licenseNursysTransactions'].map(NurseNursysTransactionDto_1.NurseNursysTransactionDtoFromJSON)),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'ncsbnId': json['ncsbnId'],
        'dateOfBirth': (json['dateOfBirth'] == null ? null : new Date(json['dateOfBirth'])),
        'line1': json['line1'],
        'line2': json['line2'],
        'city': json['city'],
        'state': json['state'],
        'postalCode': json['postalCode'],
    };
}
function NurseLicenseBatchDtoToJSON(json) {
    return NurseLicenseBatchDtoToJSONTyped(json, false);
}
function NurseLicenseBatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'nurseProfileId': value['nurseProfileId'],
        'licenseNumber': value['licenseNumber'],
        'jurisdiction': (0, State_1.StateToJSON)(value['jurisdiction']),
        'licenseType': value['licenseType'],
        'status': (0, LicenseStatus_1.LicenseStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'expirationDate': (value['expirationDate'] == null ? null : value['expirationDate'].toISOString().substring(0, 10)),
        'statusLastUpdatedAt': (value['statusLastUpdatedAt'] == null ? null : value['statusLastUpdatedAt'].toISOString().substring(0, 10)),
        'compactStatus': (0, CompactStatus_1.CompactStatusToJSON)(value['compactStatus']),
        'lastNursysTransactionId': value['lastNursysTransactionId'],
        'licenseNursysTransactions': (value['licenseNursysTransactions'] == null ? null : value['licenseNursysTransactions'].map(NurseNursysTransactionDto_1.NurseNursysTransactionDtoToJSON)),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'ncsbnId': value['ncsbnId'],
        'dateOfBirth': (value['dateOfBirth'] == null ? null : value['dateOfBirth'].toISOString().substring(0, 10)),
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
    };
}
//# sourceMappingURL=NurseLicenseBatchDto.js.map